import { useState, useEffect, useRef } from 'react'

const useThrottledState = (initialValue, limit = 1000) => {
  const [state, setState] = useState(initialValue)
  const throttledValue = useRef(initialValue)
  const lastUpdate = useRef(Date.now())

  useEffect(() => {
    const timerId = setInterval(() => {
      const now = Date.now()

      if (now - lastUpdate.current >= limit) {
        lastUpdate.current = now
        setState(throttledValue.current)
      }
    }, limit)

    return () => clearInterval(timerId)
  }, [limit])

  const setThrottledState = (newValue) => {
    throttledValue.current = newValue
    lastUpdate.current = Date.now()
  }

  return [state, setThrottledState]
}

export default useThrottledState
